import React, { useEffect, useState } from 'react';
import { useSearchParams, Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  CircularProgress,
  Button,
  Paper,
  Alert
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { verifyEmail } from '../api';
import { useLang } from '../i18n';

const MailValidator = () => {
  const { t, setLang } = useLang();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error', 'invalid'

  const email = searchParams.get('email');
  const code = searchParams.get('code');
  const linkLang = searchParams.get('lang');

  // письмо часто открывают на другом устройстве — язык берём из ссылки
  useEffect(() => {
    if (linkLang === 'it' || linkLang === 'ru') setLang(linkLang);
  }, [linkLang, setLang]);

  useEffect(() => {
    const validate = async () => {
      if (!email || !code) {
        setStatus('invalid');
        return;
      }
      try {
        await verifyEmail(email, code);
        setStatus('success');
      } catch (error) {
        setStatus('error');
      }
    };

    validate();
  }, [email, code]);

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          mt: 8,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: 2
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          {t('confirm.title')}
        </Typography>

        {status === 'loading' && (
          <Box sx={{ my: 4, textAlign: 'center' }}>
            <CircularProgress size={60} />
            <Typography sx={{ mt: 2 }}>{t('confirm.checking')}</Typography>
          </Box>
        )}

        {status === 'success' && (
          <Box sx={{ my: 4, textAlign: 'center' }}>
            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              {t('confirm.success')}
            </Typography>
            <Typography sx={{ mb: 3 }}>
              {t('confirm.canLogin')}
            </Typography>
            <Button
              component={RouterLink}
              to="/login"
              variant="contained"
              color="primary"
              size="large"
            >
              {t('confirm.toLogin')}
            </Button>
          </Box>
        )}

        {status === 'error' && (
          <Box sx={{ my: 4, textAlign: 'center' }}>
            <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
            <Alert severity="error" sx={{ textAlign: 'left' }}>
              <b>{t('confirm.errorTitle')}</b>
              <br />
              {t('confirm.errorText')}
            </Alert>
          </Box>
        )}

        {status === 'invalid' && (
          <Box sx={{ my: 4, textAlign: 'center' }}>
            <ErrorOutlineIcon color="warning" sx={{ fontSize: 60, mb: 2 }} />
            <Alert severity="warning" sx={{ textAlign: 'left' }}>
              <b>{t('confirm.invalidTitle')}</b>
              <br />
              {t('confirm.invalidText')}
            </Alert>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default MailValidator;
